import { useAppSelector } from "@/redux/store";
import styles from "./CourtSchema.module.scss"
import courtSchema from  "@/assets/img/courtSchema.png";
import { fetchScheme } from "@/redux/scheme/asyncThunk";
import { useEffect } from "react";
import { useAppDispatch } from "@/redux/store";

export const CourtSchema = () => {
  const dispatch = useAppDispatch();

  const { url, isLoading } = useAppSelector((state) => state.scheme);

  useEffect(() => {
    dispatch(fetchScheme());
  }, []);

  return (
    <div className={styles.wrapper}>
      {
        !isLoading
          ? <img className={styles.img} src={url || courtSchema}/>
          : null
      }
    </div>
  )
}
